/**
 * Fades + un-blurs each page section in as it scrolls into view.
 * Progressive enhancement: sections stay fully visible until this class
 * is added, so nothing breaks if JS fails to load or run.
 */
(() => {
  if (window.Shopify && Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const sections = document.querySelectorAll('#MainContent .shopify-section');
  if (!sections.length) return;

  const REVEALED_CLASS = 'scroll-in-view';
  const STAGGER_STEP_MS = 70;
  const STAGGER_MAX_STEPS = 3;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add(REVEALED_CLASS);
        observer.unobserve(entry.target);
      }
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  sections.forEach((section, index) => {
    section.style.setProperty('--scroll-reveal-delay', `${Math.min(index, STAGGER_MAX_STEPS) * STAGGER_STEP_MS}ms`);

    const rect = section.getBoundingClientRect();
    const alreadyInView = rect.top < window.innerHeight && rect.bottom > 0;

    if (alreadyInView) {
      section.classList.add(REVEALED_CLASS);
    } else {
      observer.observe(section);
    }
  });

  document.documentElement.classList.add('scroll-animations-ready');
})();
